module.exports = __webpack_public_path__ + "img/eqBg2.a9c114e1.png";